import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'

import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Element, { size: 'small', zIndex: 3000 });

import VWave from 'v-wave'

Vue.use(dataV)
Vue.use(VWave)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
